export const SET_PARTICIPANTS = "SET_PARTICIPANTS";
export const SET_PARTICIPANT = "SET_PARTICIPANT";
